/**
 * Single place for API base URL — avoids circular imports with api.ts / geolocation.
 *
 * Development: use same-origin `/api` so Create React App proxies to the local API (see src/setupProxy.js).
 * Default API port is 5001 (see server/.env PORT). Matches production (`/api` on one host).
 * Override with REACT_APP_API_URL if the API is on another origin.
 */
export function getWebApiBaseUrl(): string {
  try {
    const { Capacitor } = require('@capacitor/core');
    if (Capacitor && Capacitor.isNativePlatform()) {
      return process.env.REACT_APP_API_URL || 'https://your-production-server.com/api';
    }
  } catch {
    // not native
  }
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }
  return '/api';
}
